The collection of possible responses.

For `SingleSelect` and `MultiSelect` this must contain between 2 and 99 elements, inclusive.
